import App from './App.vue'
import { Box, Button, Expandable, Tabs, fInput, fToggle } from '@fabric-ds/vue'
import Cleave from 'cleave-lite'
import { createSSRApp } from 'vue'
import { createRouter } from './router'

export function createApp({ isSSR = false } = {}) {
  const app = createSSRApp(App)
  const router = createRouter(isSSR)

  app.use(router)
  app.use(Box)
  app.use(Button)
  app.use(Expandable)
  app.use(Tabs)
  app.component(fInput.name, fInput)
  app.component(fToggle.name, fToggle)
  app.provide('Cleave', Cleave)
  return { app, router }
}
